/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { interpolate, InterpolationData } from '@common';
import { ContentDictionaryMapping } from '../../models/content-dictionary-mapping.type';
import { ContentDictionary } from '../../models/content-dictionary.type';
import { CONTENT_DICTIONARY_MAPPING } from '../../tokens/content-dictionary-mapping.token';
import { ContentDictionaryService } from '../content-dictionary/content-dictionary.service';

@Injectable({ providedIn: 'root' })
export class ContentService<T extends ContentDictionary = ContentDictionary> {
  private readonly contentDictionaryMapping = inject<
    ContentDictionaryMapping<T>[]
  >(CONTENT_DICTIONARY_MAPPING);
  private readonly contentDictionaryService = inject<
    ContentDictionaryService<T>
  >(ContentDictionaryService);

  constructor() {
    this.contentDictionaryService.registerContentDictionaryMapping(
      ...this.contentDictionaryMapping,
    );
  }

  getContent<K extends keyof T>(
    contentId: K,
    interpolationData?: InterpolationData,
  ): string | any {
    const contentDictionary: T | undefined =
      this.contentDictionaryService.contentDictionary;
    const content = contentDictionary?.[contentId];

    if (!content) {
      console.error(`Content not found for contentId: ${contentId.toString()}`);
      return contentId.toString();
    }

    return interpolate(content, interpolationData);
  }
}
